import React from 'react';
import { Outlet } from 'react-router-dom';
import AuthernticationInfo from 'pages/auth/authentication-info';

const AuthenticationLayout = () => {
  return (
    <section className='flex items-stretch flex-1'>
      <div className='hidden lg:block bg-[#141415]'>
        <AuthernticationInfo />
      </div>
      <div className='w-full flex-grow px-6 lg:px-0 lg:flex justify-center mt-24 lg:mt-40 flex-1'>
        <Outlet />
      </div>
    </section>
  );
};

export default AuthenticationLayout;
